import { StringKey } from '../../../lang/index';

export enum ReverseVestingColumn {
  DOCUMENTS = 'documents',
  FULL_VESTING_DATE = 'full-vesting-date',
  ISSUE_DATE = 'issue-date',
  NEXT_VESTING_DATE = 'next-vesting-date',
  NO_OF_SHARES = 'no-of-shares',
  SHARE_CLASS = 'share-class',
  UNVESTED = 'unvested',
  VALUATION_EVENT = 'valuation-event',
  VESTED = 'vested',
}

export const reverseVestingColumnTranslationKey: Record<ReverseVestingColumn, StringKey> = {
  [ReverseVestingColumn.VALUATION_EVENT]: 'VALUATION_EVENT',
  [ReverseVestingColumn.ISSUE_DATE]: 'ISSUE_DATE',
  [ReverseVestingColumn.SHARE_CLASS]: 'SHARE_CLASS',
  [ReverseVestingColumn.NO_OF_SHARES]: 'NO_OF_SHARES',
  [ReverseVestingColumn.VESTED]: 'VESTED',
  [ReverseVestingColumn.UNVESTED]: 'UNVESTED',
  [ReverseVestingColumn.NEXT_VESTING_DATE]: 'NEXT_VESTING_DATE',
  [ReverseVestingColumn.FULL_VESTING_DATE]: 'FULL_VESTING_DATE',
  [ReverseVestingColumn.DOCUMENTS]: 'DOCUMENTS',
};

export const reverseVestingColumnOrderMap = Object.keys(reverseVestingColumnTranslationKey);

/**
 * Phone layout, per the design: the event and share class move into the card header, the issue
 * date is dropped, and the two share counts gain the percentage of the schedule they represent.
 */
export enum ReverseVestingCardRowKey {
  DOCUMENT = 'document',
  FULL_VESTING = 'full-vesting',
  NEXT_VESTING = 'next-vesting',
  NO_OF_SHARES = 'no-of-shares',
  REMAINING = 'remaining',
  VESTED = 'vested',
}

export const reverseVestingCardRowTranslationKey: Record<ReverseVestingCardRowKey, StringKey> = {
  [ReverseVestingCardRowKey.NO_OF_SHARES]: 'NO_OF_SHARES',
  [ReverseVestingCardRowKey.VESTED]: 'VESTED',
  [ReverseVestingCardRowKey.REMAINING]: 'REMAINING',
  [ReverseVestingCardRowKey.NEXT_VESTING]: 'NEXT_VESTING',
  [ReverseVestingCardRowKey.FULL_VESTING]: 'FULL_VESTING_LABEL',
  [ReverseVestingCardRowKey.DOCUMENT]: 'DOCUMENT',
};

export const reverseVestingCardRowOrderMap = Object.keys(reverseVestingCardRowTranslationKey);

export enum TerminationEventColumn {
  COMPENSATION = 'compensation',
  FINAL_VESTED = 'final-vested',
  LAPSED = 'lapsed',
  REPURCHASE_PRICE = 'repurchase-price',
  SHARE_CLASS = 'share-class',
  SHARES_ISSUED = 'shares-issued',
  TERMINATION_DATE = 'termination-date',
  VALUATION_EVENT = 'valuation-event',
}

export const terminationEventColumnTranslationKey: Record<TerminationEventColumn, StringKey> = {
  [TerminationEventColumn.TERMINATION_DATE]: 'TERMINATION_DATE',
  [TerminationEventColumn.VALUATION_EVENT]: 'VALUATION_EVENT',
  [TerminationEventColumn.SHARE_CLASS]: 'SHARE_CLASS',
  [TerminationEventColumn.SHARES_ISSUED]: 'SHARES_ISSUED',
  [TerminationEventColumn.FINAL_VESTED]: 'FINAL_VESTED',
  [TerminationEventColumn.LAPSED]: 'LAPSED',
  [TerminationEventColumn.REPURCHASE_PRICE]: 'REPURCHASE_PRICE',
  [TerminationEventColumn.COMPENSATION]: 'COMPENSATION',
};

export const terminationEventColumnOrderMap = Object.keys(terminationEventColumnTranslationKey);

/** Phone layout: the same fold as the reverse vesting card, so the two sections read alike. */
export const terminationEventCardRowOrderMap = terminationEventColumnOrderMap.filter(
  (column) =>
    column !== TerminationEventColumn.VALUATION_EVENT &&
    column !== TerminationEventColumn.SHARE_CLASS,
);
